import api from 'app/api';
import getCurrentAccount from './get-current-account';
import login from './login';
import logout from './logout';

export const authApi = api.injectEndpoints({
    endpoints: (build) => ({
        login: login(build),
        logout: logout(build),
        getCurrentAccount: getCurrentAccount(build),
    }),
});

export const { useLoginMutation, useGetCurrentAccountQuery, useLogoutMutation } = authApi;
